import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { getAdminToken } from '../../lib/api';
import { defaultHomePath } from '../../lib/access';
import { isAdmin } from '../../lib/roles';

const LINKS = [
  { href: '/#features', label: 'Features' },
  { href: '/#how-it-works', label: 'How it works' },
  { href: '/pricing', label: 'Pricing' },
];

export default function PublicNav() {
  const [open, setOpen] = useState(false);
  const signedIn = !!getAdminToken();
  const appHome = defaultHomePath();
  const trySkill = signedIn
    ? (isAdmin() ? '/routing' : '/home')
    : { pathname: '/login', state: { from: { pathname: '/home' } } };

  return (
    <header className="lp-nav">
      <div className="lp-nav__inner">
        <Link to="/" className="lp-nav__brand" onClick={() => setOpen(false)}>
          <span className="lp-nav__mark">ECS</span>
          <span className="lp-nav__brand-text">Enterprise Claude Skills</span>
        </Link>

        <nav className={`lp-nav__links ${open ? 'lp-nav__links--open' : ''}`}>
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} className="lp-nav__link" onClick={() => setOpen(false)}>
              {l.label}
            </a>
          ))}
          <div className="lp-nav__actions">
            {signedIn ? (
              <>
                <Link to={isAdmin() ? '/routing' : '/home'} className="lp-btn lp-btn--ghost lp-btn--sm">
                  Try a skill
                </Link>
                <Link to={appHome} className="lp-btn lp-btn--primary lp-btn--sm">
                  {isAdmin() ? 'Dashboard' : 'Open workspace'}
                </Link>
              </>
            ) : (
              <>
                <Link to="/login" className="lp-btn lp-btn--ghost lp-btn--sm">Sign in</Link>
                <Link to={trySkill} className="lp-btn lp-btn--primary lp-btn--sm">
                  Try a skill
                </Link>
              </>
            )}
          </div>
        </nav>

        <button
          type="button"
          className="lp-nav__toggle"
          aria-label="Toggle navigation"
          onClick={() => setOpen((v) => !v)}
        >
          <span />
          <span />
          <span />
        </button>
      </div>
    </header>
  );
}
